import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-[#F5F5F7]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <Link to="/" className="inline-flex items-center gap-2 text-[#86868B] hover:text-[#1D1D1F] transition-colors">
          <ArrowLeft className="w-4 h-4" />
          Zurück zur Startseite
        </Link>

        <div className="mt-6 bg-white rounded-2xl border border-[#E5E5EA] p-6 sm:p-8 space-y-6">
          <img src="/images/mib-logo-full.png" alt="MIB Logo" className="h-12 w-auto object-contain" />
          <h1 className="text-3xl font-bold text-[#1D1D1F]">Impressum</h1>

          <section className="space-y-2 text-[#1D1D1F]">
            <p className="font-semibold">Angaben gemäß § 5 TMG</p>
            <p>Make It Media GmbH</p>
            <p>Im Kohnental 2</p>
            <p>52353 Düren</p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <p>Handelsregister: HRB 9300</p>
            <p>Registergericht: Amtsgericht Dueren</p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <p className="font-semibold">Vertreten durch:</p>
            <p>Celina Geraldes</p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <p className="font-semibold">Kontakt</p>
            <p>Telefon: +49 1573 3176758</p>
            <p>
              E-Mail:{" "}
              <a className="text-[#0071E3] hover:underline" href="mailto:hello@makeit-media.de">
                hello@makeit-media.de
              </a>
            </p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <p className="font-semibold">Umsatzsteuer-ID</p>
            <p>Umsatzsteuer-Identifikationsnummer gemaess § 27 a Umsatzsteuergesetz: DE359534107</p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <p className="font-semibold">Redaktionell verantwortlich</p>
            <p>Celina Geraldes</p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <p className="font-semibold">EU-Streitschlichtung</p>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
              <a
                className="text-[#0071E3] hover:underline break-all"
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noreferrer"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              .
            </p>
            <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <p className="font-semibold">Verbraucherstreitbeilegung/Universalschlichtungsstelle</p>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
